// extracted by mini-css-extract-plugin
module.exports = {"bullet":"bullet__KOB-P","buttonGroup":"buttonGroup__LXSXt","pagination":"pagination__5CoJi","perPage":"perPage__PJiZB","totalCount":"totalCount__i0nzu"};